import * as React from "react";

export const SvgInvited = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" width={14} height={15} fill="none" {...props}>
		<path
			fill="#fff"
			d="m11.71 5.221-.648-.446v2.392l.49-.343.736-.515c0-.135-.02-.27-.064-.397a1.398 1.398 0 0 0-.514-.691ZM7.79 10.353a1.331 1.331 0 0 1-1.54 0L2.485 7.741l-.735-.51v4.187a1.348 1.348 0 0 0 1.348 1.348h7.843a1.35 1.35 0 0 0 1.348-1.348v-4.21l-.735.514-3.765 2.631ZM1.819 5.903c-.047.137-.07.281-.069.426l.735.51.49.343V4.775l-.651.45a1.363 1.363 0 0 0-.505.678ZM7.889 3.471h1.294l-1.392-.96a1.333 1.333 0 0 0-1.54 0l-1.392.96h3.03Z"
		/>
		<path
			fill="#fff"
			d="M3.71 4.819v2.873L6.673 9.75a.604.604 0 0 0 .696 0l2.96-2.068V4.82a.613.613 0 0 0-.612-.613H5a.162.162 0 0 1-.068 0h-.608a.613.613 0 0 0-.613.613Zm4.045 4.044h-1.47a.368.368 0 0 1 0-.735h1.47a.368.368 0 1 1 0 .735ZM4.814 5.187h4.412a.368.368 0 0 1 0 .735H4.814a.368.368 0 1 1 0-.735Zm0 1.47h4.412a.368.368 0 0 1 0 .736H4.814a.368.368 0 0 1 0-.736Z"
		/>
	</svg>
);
